import moment from 'moment-timezone';
import TextUtils from '../../textUtils';

const DAYS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

const endIsNextDay = function (start, end) {
  if (!start || !end) return false;
  const startHours = parseInt(start.split(':')[0]);
  const startMinutes = parseInt(start.split(':')[1]);
  const currentHours = parseInt(end.split(':')[0]);
  const currentMinutes = parseInt(end.split(':')[1]);
  const nextDay =
    currentHours < startHours || (currentHours === startHours && currentMinutes <= startMinutes);
  return nextDay;
};

const endTimeLabel = function (start, end) {
  if (!start || !end) return end;
  const nextDay = endIsNextDay(start, end);
  return `${end}${nextDay ? ' (Next day)' : ''}`;
};

const PAD = function (num) {
  let numStr = num.toString();
  if (numStr.length === 1) {
    return `0${numStr}`;
  }
  return numStr;
};

const hoursMinsSecondsStr = function (numSeconds) {
  let displayMins = parseInt(numSeconds / 60);
  let displaySecs = parseInt(numSeconds % 60);
  let displayHours = parseInt(displayMins / 60);
  if (displayHours > 0) displayMins = parseInt(displayMins % 60);

  let displayStr = displayHours ? `${displayHours}:` : '';
  if (displayStr) {
    displayStr = `${displayStr}${PAD(displayMins)}`;
  } else {
    displayStr = `${displayMins}`;
  }
  displayStr = `${displayStr}:${PAD(displaySecs)}`;
  return displayStr;
};

const Utils = {
  endIsNextDay,
  endTimeLabel,
  hoursMinsSecondsStr,
  pad: PAD,
  formatTimeString: (date, tz) => {
    // check if we're getting a string that needs to be fixed
    if (!date) return '';
    if (typeof date === 'string') {
      date = new Date(date);
    }
    const momentInTZ = tz ? moment.tz(date.toISOString(), tz) : moment(date.toISOString());
    return momentInTZ.format('h:mma');
  },
  formatDateString: (date, tz) => {
    // check if we're getting a string that needs to be fixed
    if (!date) return '';
    if (typeof date === 'string') {
      date = new Date(date);
    }
    const momentInTZ = tz ? moment.tz(date.toISOString(), tz) : moment(date.toISOString());
    return momentInTZ.format('MMM D, YYYY');
  },
  formatDateStringNumeric: (date, tz, options) => {
    // check if we're getting a string that needs to be fixed
    if (!date) return '';
    if (typeof date === 'string') {
      date = new Date(date);
    }
    const padDigits = options && options.padDigits;
    const momentInTZ = tz ? moment.tz(date.toISOString(), tz) : moment(date.toISOString());
    if (padDigits) {
      return momentInTZ.format('MM/DD/YYYY');
    } else {
      return momentInTZ.format('M/D/YYYY');
    }
  },
  dateWithoutTime: (date) => {
    if (!date) console.warn('dateWithoutTime passed bad date');
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0);
  },
  setTimeFordateFromDate: (date, timeDate) => {
    date.setHours(timeDate.getHours());
    date.setMinutes(timeDate.getMinutes());
  },
  /**
   * Round the minutes of a date object
   * @param {date} date Date object to be rounded
   * @param {number} interval interval of rounding. defaults to 5
   * @param {number} direction direction of rounding, -1 floor, 0 round, 1 ceil. defaults to round
   * @returns date object that was modified
   */
  roundMinutes(date, interval = 5, direction = 0) {
    if (!date) console.warn('roundMinutes passed bad date');
    let minutes = date.getMinutes();
    if (direction > 0) {
      minutes = Math.ceil(minutes / interval) * interval;
    } else if (direction < 0) {
      minutes = Math.floor(minutes / interval) * interval;
    } else {
      minutes = Math.round(minutes / interval) * interval;
    }
    date.setMinutes(minutes);
    return date;
  },
  sanitizeDate(value) {
    let date = null;
    if (moment(value).isValid()) {
      date = moment(value).toDate();
    }
    return date;
  },
  DAYS,
  daysOfWeekLabel(days) {
    const sortedDays = days.slice().sort();
    let daysLabel;
    if (
      sortedDays.length > 1 &&
      sortedDays.length === sortedDays[sortedDays.length - 1] - sortedDays[0] + 1
    ) {
      daysLabel = `${TextUtils.c1(DAYS[sortedDays[0] - 1].toLowerCase())} - ${TextUtils.c1(
        DAYS[sortedDays[sortedDays.length - 1] - 1].toLowerCase()
      )}`;
    } else {
      daysLabel = sortedDays.map((d) => TextUtils.c1(DAYS[d - 1].toLowerCase()));
    }
    return daysLabel;
  },
  formatTimeStringMilitary(date, tz) {
    // check if we're getting a string that needs to be fixed
    if (!date) return '';
    if (typeof date === 'string') {
      date = new Date(date);
    }
    const momentInTZ = tz ? moment.tz(date.toISOString(), tz) : moment(date.toISOString());
    return momentInTZ.format('HH:mm');
  },
};

module.exports = Utils;
